<template>
  <div class="members">
    <v-container>
      <v-row class="mt-2" justify="center">

        <v-col cols="2" class="hidden-sm-and-down">
          <v-list class="mt-2 submenu" color="#fafafa" subheader dense>
            <v-subheader>目次</v-subheader>
            <v-list-item @click="smoothScroll('teacher')">教員</v-list-item>
            <v-list-item @click="smoothScroll('student')">学生</v-list-item>
          </v-list>
        </v-col>

        <v-col cols="10">
          <!----- title ----->
          <v-row class="mt-2" justify="center" >
            <v-col cols="12" md="10">
              <div class="text-h4 pl-4" style="text-align: center">2026年度</div>
            </v-col>
            <v-col cols="12" md="10">
              <v-alert outlined shaped color="primary">
                教員名・研究スライドのある学生名をクリックすると詳細が表示されます。
              </v-alert>
            </v-col>
          </v-row>

          <!----- teacher ----->
          <v-row class="mt-4" justify="center">
            <v-col cols="12" md="10">
              <div id="teacher" style="padding-top: 20px;" class="heading text-h4 pl-4">教員</div>
            </v-col>
          </v-row>

          <v-fade-transition mode="out-in">
            <div class="mt-4">
              <v-row justify="center">
                <v-col v-for="teacher in teachers" :key="teacher.id" cols="12" md="10">
                  <v-card :to="teacher.link">
                    <v-card-title class="title">{{ teacher.name }}</v-card-title>
                    <v-card-subtitle>{{ teacher.position }}</v-card-subtitle>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-fade-transition>

          <!----- Coteacher ----->
          <!-- <v-row class="mt-4" justify="center">
            <v-col cols="12" md="10">
              <div id="coteacher" style="padding-top: 20px;" class="heading text-h4 pl-4 mt-8">連携研究室教員</div>
            </v-col>
          </v-row> -->

          <v-fade-transition mode="out-in">
            <div class="mt-4">
              <v-row justify="center">
                <v-col v-for="coteacher in coteachers" :key="coteacher.id" cols="12" md="10">
                  <v-card :to="coteacher.link">
                    <v-card-title class="title">{{ coteacher.name }}</v-card-title>
                    <v-card-subtitle>{{ coteacher.position }}</v-card-subtitle>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-fade-transition>

          <!----- 学生（members.csv から自動生成） ----->
          <v-row class="mt-4" justify="center">
            <v-col cols="12" md="10">
              <div id="student" style="padding-top: 20px;" class="heading text-h4 pl-4 mt-8">学生</div>
            </v-col>
          </v-row>

          <v-row class="my-4" justify="center">
            <v-col cols="12" md="10">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">学年</th>
                      <th class="text-left">名前</th>
                      <th class="text-left">小グループ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(row, i) in displayRows">
                      <tr v-if="row.sep" :key="'sep' + i" class="grade-separator">
                        <td colspan="3"></td>
                      </tr>
                      <tr v-else :key="i">
                        <td>{{ row.grade }}</td>
                        <td>
                          <a v-if="row.slide" class="member-link" @click="openSlide(row)">{{ row.name }}</a>
                          <span v-else>{{ row.name }}</span>
                        </td>
                        <td>{{ row.group }}</td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>

              <div v-if="sortedStudents.length === 0" class="mt-4">
                メンバー情報を読み込めませんでした。（public/members.csv をご確認ください）
              </div>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
    </v-container>

    <!-- 研究スライド表示用ダイアログ -->
    <v-dialog v-model="dialog" max-width="1000">
      <v-card>
        <v-card-title class="title">
          {{ selected.name }}<span v-if="selected.grade">（{{ selected.grade }}）</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-img v-if="selected.slide" :src="slideUrl(selected.slide)" contain eager></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import members from './data/members.js'

export default {
  name: "Members",
  data: () => ({
    teachers: members.teachers,
    coteachers: members.coteachers,
    students: [],
    dialog: false,
    selected: {},
    // 学年の表示順（上にくるほど先輩）
    gradeOrder: ['D3', 'D2', 'D1', 'RS', 'M2', 'M1', 'B4'],
  }),
  computed: {
    sortedStudents() {
      const rank = (g) => {
        const i = this.gradeOrder.indexOf(g);
        return i === -1 ? this.gradeOrder.length : i;
      };
      return [...this.students].sort((a, b) => rank(a.grade) - rank(b.grade));
    },
    // 学年が変わるごとに区切り行（sep）を挟んだ表示用リスト
    displayRows() {
      const out = [];
      let prev = null;
      for (const m of this.sortedStudents) {
        if (prev !== null && m.grade !== prev) out.push({ sep: true });
        out.push(m);
        prev = m.grade;
      }
      return out;
    },
  },
  async created() {
    try {
      const res = await fetch('/members.csv');
      const text = await res.text();
      this.students = this.parseCsv(text);
    } catch (e) {
      this.students = [];
    }
  },
  methods: {
    // ヘッダ名から列を判別して { grade, name, group, slide } の配列に変換する
    parseCsv(text) {
      const rows = this.splitCsv(text.replace(/^\uFEFF/, ''));
      if (rows.length === 0) return [];

      // 先頭にタイトル行などがあっても、見出し行（「名前」を含む行）を自動で探す
      const nameHeaders = ['名前', '氏名', 'name', 'Name'];
      const headerRowIdx = rows.findIndex(
        r => r.some(c => nameHeaders.includes((c || '').trim()))
      );
      if (headerRowIdx === -1) return [];   // 見出し行が見つからない

      const header = rows[headerRowIdx].map(h => (h || '').trim());
      const find = (...cands) =>
        header.findIndex(h => cands.includes(h));
      const idxGrade = find('学年', 'grade', 'Grade');
      const idxName  = find('名前', '氏名', 'name', 'Name');
      const idxGroup = find('小グループ', 'グループ', 'group', 'Group');
      const idxSlide = find('スライド画像', 'スライド', 'slide', 'Slide');

      return rows.slice(headerRowIdx + 1)
        .filter(r => r.some(c => c && c.trim() !== ''))   // 空行を除外
        .map(r => ({
          grade: idxGrade >= 0 ? (r[idxGrade] || '').trim() : '',
          name:  idxName  >= 0 ? (r[idxName]  || '').trim() : '',
          group: idxGroup >= 0 ? (r[idxGroup] || '').trim() : '',
          slide: idxSlide >= 0 ? (r[idxSlide] || '').trim() : '',
        }))
        .filter(m => m.name !== '');                        // 名前が無い行を除外
    },
    // ダブルクォート対応の簡易CSVパーサ
    splitCsv(text) {
      const rows = [];
      let row = [], field = '', inQuotes = false;
      for (let i = 0; i < text.length; i++) {
        const c = text[i];
        if (inQuotes) {
          if (c === '"') {
            if (text[i + 1] === '"') { field += '"'; i++; }
            else inQuotes = false;
          } else field += c;
        } else {
          if (c === '"') inQuotes = true;
          else if (c === ',') { row.push(field); field = ''; }
          else if (c === '\n') { row.push(field); rows.push(row); row = []; field = ''; }
          else if (c === '\r') { /* 無視 */ }
          else field += c;
        }
      }
      if (field !== '' || row.length > 0) { row.push(field); rows.push(row); }
      return rows;
    },
    slideUrl(file) {
      return `/member_slides/${file}`;
    },
    openSlide(m) {
      this.selected = m;
      this.dialog = true;
    },
    smoothScroll(target) {
      const element = document.getElementById(target);
      const offset = element.offsetTop; // オフセット位置を取得

      window.scrollTo({
        top: offset,
        behavior: 'smooth' // スムーズスクロールを有効にする
      });
    },
  }
};
</script>

<style scoped>
.heading {
  border-bottom: 2px solid #000;
}
.submenu {
  position:fixed;
}
.member-link {
  color: #002884;
  cursor: pointer;
  text-decoration: underline;
}
/* 学年の区切り（空白行＋濃い横線） */
.grade-separator td {
  height: 20px;
  padding: 0;
  border-bottom: 3px solid #333 !important;
  background-color: #fafafa;
}
</style>
